import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import ChangeKeywordsExclusions from 'components/Dashboard/utilities/changeKeywordExclusions';
import ChangeKeywordsCategory from 'components/Dashboard/utilities/changeKeywordsCategory';
import getUrlParam, { getUrlParamRaw, decodeUrlQueryValue } from 'components/Dashboard/utilities/getUrlParam';

const useGetParliamentaryContributions = (props) => {
  const { generalApiCall } = useGeneralApiCall();
  const getTotalContributions = async (props) => {
    const { contentUrl, type, source, localURL } = props ?? {};
    const topicParam = getUrlParam('topic-id', localURL);
    const searchParam = getUrlParamRaw('or', null, localURL) ?? getUrlParamRaw('search', null, localURL);
    const andKeywordsParam = getUrlParamRaw('and', null, localURL);
    const notKeywordsParam = getUrlParamRaw('not', null, localURL);
    const contactIdParam = getUrlParam('contact-id', localURL);

    let pathname = `/api/search/query`;
    const method = 'post';

    const getContentType = () => {
      if (type === 'scottish-official-report') {
        return 'ScotlandCountrySpecificParliamentaryContribution';
      } else if (type === 'welsh-official-report') {
        return 'WalesCountrySpecificParliamentaryContribution';
      } else if (type === 'senedd-committee-transcript') {
        return 'SeneddCommitteeTranscriptContribution';
      } else if (type === 'crec') {
        return 'CREC';
      } else {
        return 'ParliamentaryContribution';
      }
    };

    let filters = [
      { field: 'contentType', value: getContentType(), operator: 'str_eq' },
      { field: 'contentUrl', value: contentUrl, operator: 'str_eq' },
    ];
    if (contactIdParam) {
      filters.push({ field: 'contactIds', value: contactIdParam, operator: 'str_eq' });
    }

    let requestProperties = {
      collaspeField: null,
      type: 'ParliamentaryRecord',
      sort: { field: 'contributionOrder', order: 'ASC' },
      pageSize: 10000,
      filters,
    };
    if (topicParam && topicParam !== 'none') {
      pathname = `/api/search/query-by-keyword-list`;
      requestProperties = {
        ...requestProperties,
        keywordListId: topicParam === 'all' ? null : parseInt(topicParam),
      };
    }

    if (topicParam === 'none') {
      requestProperties = { ...requestProperties, query: '' };
    }

    if (searchParam) {
      requestProperties = {
        ...requestProperties,
        query: ChangeKeywordsCategory(decodeUrlQueryValue(searchParam)?.split(',')),
        andQueries: andKeywordsParam ? ChangeKeywordsExclusions(decodeUrlQueryValue(andKeywordsParam).split(',')) : [],
        mustNotQueries: notKeywordsParam
          ? ChangeKeywordsExclusions(decodeUrlQueryValue(notKeywordsParam).split(','))
          : [],
      };
    }

    let results = await generalApiCall({
      pathname,
      requestProperties,
      requestSource: source,
      method,
      needsAuthentication: !!topicParam,
    });
    return results;
  };

  const getContactIdInformation = async (contactId, source) => {
    const pathname = '/api/search/query';
    const method = 'post';
    const requestProperties = {
      query: '',
      type: 'stakeholder',
      pageNumber: 1,
      pageSize: 1,
      filters: [{ field: 'id', value: contactId, operator: 'str_eq' }],
    };
    const results = generalApiCall({ pathname, method, requestProperties, requestSource: source });
    return results;
  };

  return { getTotalContributions, getContactIdInformation };
};

export default useGetParliamentaryContributions;
